export const getTotalInventoryItems = (arr) =>
  arr?.reduce((acc, obj) => acc + obj.amount, 0);
